export const UPLOAD_ASSET = 'uploadAsset';